import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { agentOptionLabel, mapAgentProfile } from "@/utils/agent.js";

export const useAgentStore = defineStore("agent", () => {
  const agentsById = ref({});
  const agentIds = ref([]);
  const loaded = ref(false);

  const agents = computed(() =>
    agentIds.value.map((id) => agentsById.value[id]).filter(Boolean),
  );

  function setAgents(list) {
    const next = {};
    const ids = [];
    for (const profile of list) {
      const mapped = mapAgentProfile(profile);
      if (mapped.id === null || mapped.id === undefined) continue;
      next[mapped.id] = mapped;
      ids.push(mapped.id);
    }
    agentsById.value = next;
    agentIds.value = ids;
    loaded.value = true;
  }

  function labelById(id) {
    const profile = agentsById.value[id];
    return profile ? agentOptionLabel(profile) : String(id);
  }

  return {
    agents,
    loaded,
    setAgents,
    labelById,
  };
});
